// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styledBoxStyle } from "@conklin/XDL/Components/Common/Box";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, color, mergeWithCss } from "@conklin/XDL/Utilities";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    microCopyText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
    wrapper?: InjectableCss;
}

const label: TypographyPresentationProps = {
    variant: "h6",
    forwardAs: "span",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
        letter-spacing: 0;
    `,
};
const value: TypographyPresentationProps = {
    variant: "h6",
    forwardAs: "span",
    css: css`
        margin-bottom: 0;
        margin-left: auto;
        letter-spacing: 0;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 12px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            margin: 0;
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...mergeWithCss(label, { size: 16, lineHeight: "19px" }),
    },
    totalValue: {
        ...mergeWithCss(value, { size: 16, lineHeight: "19px" }),
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 0;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            ${styledBoxStyle}
            ${avoidBreakInsidePrintElement}
        `,
    },
    microCopyText: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
        css: css`
            display: block;
            padding-top: 12px;
        `,
    },
};
